import React from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonLink from '../../Form/ButtonLink';
import ProfileTitle from '../../../Pages/Profile/ProfileTitle';
import { TbMoodConfuzed } from 'react-icons/tb';
import { ImSpinner8 } from 'react-icons/im';
import { formatCurrentAddress } from '../../../Utils/Formatters';
import { getIconAddress } from '../../../Utils/Constants/Global';
import { useStoreContext } from '../../../Contexts/StoreContext';
import { useTranslation } from 'react-i18next';

interface CardProfileAddressesProps {
     loading: boolean;
     list: any[];
}

const CardProfileAddresses = ({ loading = true, list }: CardProfileAddressesProps) => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { currentAddress } = useStoreContext();

  return (
    <div className='flex flex-col gap-4 w-full'>
      <ProfileTitle className='h-auto'>{t('profile.addresses.title')}</ProfileTitle>
      <div className="flex flex-col h-full divide-y rounded-none divide-gray-100">
            {loading
                ?   <div className="flex items-center gap-1 text-gray-500"><ImSpinner8 className="animate-spin" /><span>{t('layout.loading')}</span></div>
                :   list.length === 0
                        ?   <div className="flex items-center gap-1 text-gray-500"><TbMoodConfuzed /> <span>{t('profile.addresses.no_address_found')}</span></div>
                        :   list.map((address: any, index: number) => {
                              const isCurrent = currentAddress && currentAddress.id === address.id;
                              return (
                                <div key={address.id ?? index} className='flex gap-1 py-2'>
                                  { address.title && 
                                    <div>{ getIconAddress(address.title, 18) }</div> }
                                  <div className='grid gap-1'>
                                    { address.title && 
                                      <div className='inline-flex gap-1'>
                                        <span className='font-semibold'>{ address.title }</span>
                                        { isCurrent && <span className='text-gray-400'>({t('profile.addresses.current_label')})</span> }
                                      </div>
                                    }
                                    <span className='leading-none text-gray-400'>{ formatCurrentAddress(address) }</span>
                                  </div>
                                </div>
                            )})
            }
        </div>
        {!loading && list.length > 0 && <ButtonLink onClick={() => navigate('/perfil/meus-enderecos')} className='w-full md:w-max'>{t('profile.addresses.button_card_home_label')}</ButtonLink>}
    </div>
  )
}

export default CardProfileAddresses;